import React, { useState, useEffect } from 'react';
// Zde si ponecháváte původní importy pro místní soubory
import img1 from './images/web/img1.jpg';
import img2 from './images/web/img2.jpg';
import img3 from './images/web/img3.jpg';
import img5 from './images/web/img5.jpg';
import img6 from './images/web/img6.jpg';
import img7 from './images/web/img7.jpg';
import img8 from './images/web/img8.jpg';
import img9 from './images/web/img9.jpg';
import img10 from './images/web/img10.jpg';
// import img11 from './images/web/img11.jpg';
// import img13 from './images/web/img13.jpg';
import img14 from './images/web/img14.jpg';
import img15 from './images/web/img15.jpg';
import img16 from './images/web/img16.jpg';
import img17 from './images/web/img17.jpg';
import img18 from './images/web/img18.jpg';
import img19 from './images/web/img19.jpg';
import img20 from './images/web/img20.jpg';
import img21 from './images/web/img21.jpg';
import img22 from './images/web/img22.jpg';
import img23 from './images/web/img23.jpg';
import img24 from './images/web/img24.jpg';

import img25 from './images/web/img25.jpg';
import img26 from './images/web/img26.jpg';
import img27 from './images/web/img27.jpg';
import img28 from './images/web/img28.jpg';
import img29 from './images/web/img29.jpg';
import img30 from './images/web/img30.jpg';
import img31 from './images/web/img31.jpg';
import img32 from './images/web/img32.jpg';
import img33 from './images/web/img33.jpg';
import img34 from './images/web/img34.jpg';
import img35 from './images/web/img35.jpg';
import img36 from './images/web/img36.jpg';
import img37 from './images/web/img37.jpg';
import img38 from './images/web/img38.jpg';
import img39 from './images/web/img39.jpg';
import img40 from './images/web/img40.jpg';
import img41 from './images/web/img41.jpg';
import img42 from './images/web/img42.jpg';
import img43 from './images/web/img43.jpg';
import img45 from './images/web/img45.jpg';
import img46 from './images/web/img46.jpg';
import img47 from './images/web/img47.jpg';
import img48 from './images/web/img48.jpg';

import Modal from './Modal';
import ContentImage from './ContentImage';

const images = [
        img1, img2, img3, img5, img6, img7, img8,
        img9, img10, img14, img15, img16,
        img17, img18, img19, img20, img21, img22, img23, img24,
        img25, img26, img27, img28, img29, img30, img31, img32,
        img33, img34, img35, img36, img37, img38, img39, img40, img41, img42, img43, img45, img46, img47, img48
    ].reverse();


export default function Gallery() {
    const [index, setIndex] = useState(null);
    useEffect(() => {
        if (index === null) return;
        const keydown = event => {
            if (event.key === 'ArrowLeft') setIndex(n => (n - 1 + images.length) % images.length);
            if (event.key === 'ArrowRight') setIndex(n => (n + 1) % images.length);
        };
        window.addEventListener('keydown', keydown);
        return () => window.removeEventListener('keydown', keydown);
    }, [index]);
    return <section id="fotogalerie" className="py-20 bg-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="content-page-heading"><p className="eyebrow">Naše společná cesta</p><h1>Pohyb. Lidé. Okamžiky.</h1><p>Nahlédněte do našich lekcí, setkání a chvil, kdy jsme se zastavili společně.</p></div>
            <div className="gallery-grid">{images.map((src, n) => <button type="button" className="gallery-item" key={src} onClick={() => setIndex(n)} aria-label={`Zvětšit fotografii ${n + 1}`}>
                <ContentImage src={src} alt={`Čchi-kung s Tomášem Číhalem – fotografie ${n + 1}`} loading="lazy" decoding="async" />
                <span className="gallery-number" aria-hidden="true">{String(n + 1).padStart(2, '0')} ↗</span>
            </button>)}</div>
        </div>
        {index !== null && <Modal label={`Fotografie ${index + 1} z ${images.length}`} onClose={() => setIndex(null)}>
            <ContentImage src={images[index]} alt={`Čchi-kung – fotografie ${index + 1}`} className="modal-image" />
            <div className="gallery-controls"><button type="button" className="button button-secondary" onClick={() => setIndex(n => (n - 1 + images.length) % images.length)} aria-label="Předchozí fotografie">←</button><span aria-live="polite">{index + 1} / {images.length}</span><button type="button" className="button button-secondary" onClick={() => setIndex(n => (n + 1) % images.length)} aria-label="Další fotografie">→</button></div>
        </Modal>}
    </section>;
}
